module.exports = __webpack_public_path__ + "img/power-restore.a4bf2989.svg";